// extracted by mini-css-extract-plugin
export var buttonWrapperStyle = "toc_icon_button-module--buttonWrapperStyle--wpNd2";
export var disabledStyle = "toc_icon_button-module--disabledStyle--o59DZ";
export var isActiveStyle = "toc_icon_button-module--isActiveStyle--jjPRJ";
export var isReversedStyle = "toc_icon_button-module--isReversedStyle--reaVN";
export var textStyle = "toc_icon_button-module--textStyle--mwFUo";